<div class="container-fluid  d-flex flex-column hcm-custom-screen-profile">
    <nav *ngIf="showActionButtons()" aria-label="breadcrumb" class="d-none d-md-block">
        <ol class="breadcrumb">
            <li class="breadcrumb-item hcm-breadcrumb-text">
                <a routerLink="/home">{{ 'stepper.home' | translate }}</a>
            </li>
            <li class="breadcrumb-item active hcm-breadcrumb-text" aria-current="page">
                {{ 'header.edit_profile' | translate }}
            </li>
        </ol>
    </nav> 
    <div class="row mt-1">
        <div class="hcm-header">
            {{ firstName}} #({{ workDayId }})
        </div>
    </div>

    <mat-card  class="p-3 mt-3" appearance="outlined">
        <div class="alert alert-danger" role="alert" *ngIf="errorList.length">
            <span *ngFor="let error of errorList">{{error}}</span><br />
        </div>
        <form [formGroup]="userForm">
            <div class="row align-item-center">
                <div class="row d-md-none d-block">
                    <div class="col-12 col-md-3">
                        <label for="namc" class="hcm-label">NAMC</label>
                        <p class="hcm-value">TMMK</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <label for="plant" class="hcm-label">{{ 'PLANT' | translate }}<span
                                class="hcm-mandatory">*</span></label>
                        <mat-select  id="shop" class="rounded border p-2 hcm-value cu" placeholder="Select plant"
                            formControlName="plant">
                            <mat-option *ngFor="let plant of plants"
                                [value]="plant">{{plant}}</mat-option>
                        </mat-select>
                        <small class="hcm-error-msg"
                            *ngIf="userForm.get('plant').hasError('required') && userForm.get('plant').touched">
                            Please select plant to proceed.
                        </small>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-3">
                        <label for="shop" class="hcm-label">{{ 'SHOP' | translate }} <span
                                class="hcm-mandatory">*</span></label>
                        <mat-select id="shop" class="rounded border p-2 hcm-value cu" placeholder="Select shop"
                            formControlName="shop">
                            <mat-option *ngFor="let shop of shops" [value]="shop">{{shop}}</mat-option>
                        </mat-select>
                        <small class="hcm-error-msg"
                            *ngIf="userForm.get('shop').hasError('required') && userForm.get('shop').touched">
                            Please select shop to proceed.
                        </small>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-3">
                        <label for="lineName" class="hcm-label">{{ 'LINE_NAME' | translate }} <span
                                class="hcm-mandatory">*</span></label>
                        <mat-select multiple id="lineName" class="rounded border p-2 hcm-value cu"
                            placeholder="Select line name" formControlName="lineName">
                            <mat-option *ngFor="let line of lineNames" [value]="line">{{line}}</mat-option>
                        </mat-select>
                        <small class="hcm-error-msg"
                            *ngIf="userForm.get('lineName').hasError('required') && userForm.get('lineName').touched">
                            Please select line name to proceed.
                        </small>
                    </div>
                </div>
            </div>
        </form>
    </mat-card>
</div>

<hr class="mobile-horizontal-line d-block d-md-none">


 <mat-toolbar class="mt-auto">
        <mat-toolbar-row class="footer-blue">
            <!-- Desktop: Back button -->
            <div class="d-none d-md-block">
                <button *ngIf="showActionButtons()" class="hcm-back-btn"  (click)="navigateToHome()">
                    <img src="../../../assets/img/navigation_blue.svg" alt="back" class="me-1 mb-1">
                    {{ 'vehicleInfo.buttons.back' | translate }}
                </button>
            </div>

            <!-- Mobile: Cancel and Save buttons -->
            <div class="d-flex gap-2 justify-content-end w-100 d-md-none">
                <button *ngIf="showActionButtons()" class="hcm-blue-btn" (click)="onDetailCanceled()">
                    <a>{{ 'profile.buttons.cancel' | translate }}</a>
                </button>
                <button class="hcm-black-btn-profile" (click)="onDetailSaved()">
                    <span>{{ 'profile.buttons.save' | translate }}</span> 
                </button>
            </div>

            <!-- Desktop: Cancel and Save buttons (align to right) -->
            <div class="ms-auto d-none d-md-flex gap-2">
                <button *ngIf="showActionButtons()" class="hcm-blue-btn" (click)="onDetailCanceled()">
                    <a>{{ 'profile.buttons.cancel' | translate }}</a>
                </button>
                <button class="hcm-black-btn" (click)="onDetailSaved()">
                    <span>{{ 'profile.buttons.save' | translate }}</span> 
                </button>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
